<template>
    <v-content>
        <!-- Header -->
        <section v-if="$vuetify.breakpoint.smAndUp" class="elevation-10">
            <google-map></google-map>
        </section>
        <!-- Parallax -->
        <section v-else class="elevation-10">
            <v-parallax src="public/dividers/div_6_min.png" height="200">
                <v-layout column align-center justify-center class="white--text mt-5">
                    <div v-lang.contactTitle1Mobile class="font-title-mobile text-xs-center"></div>
                </v-layout>
            </v-parallax>
        </section>
        <!-- Content -->
        <section>
            <v-layout row wrap justify-center align-center class="mt-5">
                <v-flex v-lang.contactTitle1 xs12 class="font-heading" text-xs-center></v-flex>
                <v-flex v-lang.contactTitle1Des xs12 style="text-align: justify;" text-xs-center class="mt-3 mb-2"></v-flex>
            </v-layout>
            <!-- Contact Information -->
            <v-layout column wrap class="mt-3 mb-0">
                <v-container grid-list-xl>
                    <v-layout row wrap align-center justify-center>
                        <v-flex xs12 md4>
                            <v-card class="elevation-10 blue-grey darken-1">
                                <v-card-title v-lang.contactItem1 class="font-subheading justify-center pb-0"></v-card-title>
                                <v-card-text class="text-xs-center" style="height: 175px">
                                    <v-layout row wrap>
                                        <v-flex xs12>
                                             <v-icon class="blue--text ">phone</v-icon>
                                            <span>+358 45 7731 1552</span>
                                        </v-flex>
                                        <v-flex xs12>
                                            <v-icon class="amber--text">email</v-icon>
                                            <span>
                                                esa.karppinen@electrowaves.fi
                                            </span>
                                        </v-flex>
                                    </v-layout>                                 
                                </v-card-text>
                            </v-card>
                        </v-flex>
                        <v-flex xs12 md4>
                            <v-card class="elevation-10 blue-grey darken-2">
                                <v-card-title v-lang.contactItem2 class="font-subheading justify-center pb-0"></v-card-title>
                                <v-card-text class="text-xs-center" style="height: 175px">
                                    <v-layout row wrap>
                                        <v-flex xs12>
                                             <v-icon class="blue--text ">phone</v-icon>
                                            <span>+358 45 7731 1550</span>
                                        </v-flex>
                                        <v-flex xs12>
                                            <v-icon class="amber--text">email</v-icon>
                                            <span>
                                                virtual@electrowaves.fi
                                            </span>
                                        </v-flex>
                                    </v-layout> 
                                </v-card-text>
                            </v-card>
                        </v-flex>
                        <v-flex xs12 md4>
                            <v-card class="elevation-10 blue-grey darken-3">
                                <v-card-title v-lang.contactItem3 class="font-subheading justify-center pb-0"></v-card-title>
                                <v-card-text class="text-xs-center" style="height: 175px">
                                    <v-layout row wrap>
                                    <v-flex xs12>
                                        <v-icon class="blue--text ">phone</v-icon>
                                        <span> +358 020 1200 100</span>
                                    </v-flex>
                                    <v-flex xs12>
                                        <v-icon class="amber--text ">email</v-icon>
                                        <span v-lang.contactMail></span>
                                    </v-flex>
                                    <v-flex xs12>
                                        <v-icon class="red--text ">room</v-icon>
                                        <span v-lang.contactAddress></span>
                                    </v-flex>
                                    </v-layout>
                                </v-card-text>
                            </v-card>
                        </v-flex>
                    </v-layout>
                </v-container>
            </v-layout>
            <!-- Social Icons -->
            <v-layout row wrap>
                <v-flex xs12>
                    <v-card class="elevation-0 transparent">
                        <v-card-title primary-title class="layout justify-center">
                            <div v-lang.contactTitle2 class="font-heading"></div>
                        </v-card-title>
                    </v-card>
                </v-flex>
                <v-flex xs12 class="mb-5">
                    <v-card class="elevation-0 transparent">
                        <v-card-text style="text-align: justify;" class=" text-xs-center">
                            <a href="http://www.facebook.com/ElectroWavesOy/">
                                <img src="public/icons/facebook_white_500.png" class="mx-3" style="width: 35px">
                            </a>
                                <a href="http://twitter.com/electrowavesoy">
                                    <img src="public/icons/twitter_white_500.png" class="mx-3" style="width: 35px">
                            </a>
                                    <a href="http://instagram.com/ElectroWavesOy/">
                                        <img src="public/icons/instagram_white_500.png" class="mx-3" style="width: 35px"></a>
                        </v-card-text>
                    </v-card>
                </v-flex>
            </v-layout>
        </section>
        <!-- Map -->
        <google-map v-if="$vuetify.breakpoint.smAndDown"></google-map>
        <!-- Footer -->
        <c-footer></c-footer>
    </v-content>
</template>

<script>
import GoogleMap from "./GoogleMap";
import CFooter from "./Footer";
export default {
  data() {
    return {};
  },
  components: {
    GoogleMap,
    CFooter
  }
};
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/components/Contact.vue